import { FC, ReactNode } from 'react'
import cn from 'classnames'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import classes from './createLinkSections.module.css'

type CreateLinkSectionTitleProps = {
  title: string
  /** Текст или ReactNode для InfoComp (как в createLinkBlockInfoContent). */
  infoText?: ReactNode
  extra?: ReactNode
  className?: string
}

/** Заголовок секции create-link: темнее и заметнее, чем label поля. */
const CreateLinkSectionTitle: FC<CreateLinkSectionTitleProps> = ({
  title,
  infoText,
  extra,
  className,
}) => {
  return (
    <div className={cn(classes.titleRow, className)}>
      <div className={classes.sectionTitle}>{title}</div>
      {infoText != null && infoText !== false ? (
        <InfoComp text={infoText} />
      ) : null}
      {extra}
    </div>
  )
}

export default CreateLinkSectionTitle
